import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

import FormControl from '@material-ui/core/FormControl'
import FormHeading from 'components/molecules/FormHeading'
import SubmitButton from 'components/atoms/buttons/SubmitButton'

export const styles = theme => ({
  root: {
    textAlign: 'center',
  },
  formControl: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1),
  },
  hiddenButton: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
})

function FormResult(props) {
  const {
    classes,
    heading,
    onClick,
    hideButton,
    subHeading,
    buttonLabel,
    hideButtonOnMobile,
    className: classNameProp,
  } = props

  return (
    <div className={classNames(classes.root, classNameProp)}>
      <FormHeading heading={heading} subHeading={subHeading} />
      <FormControl
        className={classNames(
          classes.formControl,
          hideButtonOnMobile && classes.hiddenButton
        )}
        fullWidth>
        {!hideButton && (
          <SubmitButton
            autoFocus
            size="large"
            type="button"
            color="primary"
            onClick={onClick}
            variant="primary">
            {buttonLabel || 'Return to login'}
          </SubmitButton>
        )}
      </FormControl>
    </div>
  )
}

FormResult.defaultProps = {
  hideButton: false,
}

FormResult.propTypes = {
  onClick: PropTypes.func,
  heading: PropTypes.string,
  hideButton: PropTypes.bool,
  className: PropTypes.string,
  subHeading: PropTypes.string,
  buttonLabel: PropTypes.string,
  hideButtonOnMobile: PropTypes.bool,
  classes: PropTypes.object.isRequired,
}

FormResult.defaultProps = {}

export default withStyles(styles)(FormResult)



// WEBPACK FOOTER //
// ./src/components/organisms/FormResult.js